import {
  TooltipLink,
  type TooltipLinkProps,
} from "@/v2-backoffice-client/components/link"
import { MAP_LAYER_MONITOR_SOURCE } from "@/v2-backoffice-client/layer/layer.constants"
import type { UptimeTargetFragment } from "@/v2-backoffice-client/uptime/__types__/uptime.fragment"

// Sources whose Identifier maps onto a backoffice entity reachable
// via a separate view-sheet route. When the current target is one of
// these we render a "View <entity>" button in the toolbar so the
// operator can pivot from an incident to the entity that owns it.
const SOURCE_TO_BACKLINK: Record<
  string,
  { kind: "layer"; label: string } | undefined
> = {
  [MAP_LAYER_MONITOR_SOURCE]: { kind: "layer", label: "View layer" },
}

export type UptimeTargetLinkProps = Omit<TooltipLinkProps, "target"> & {
  target: UptimeTargetFragment
}

function UptimeTargetLink(props: UptimeTargetLinkProps) {
  const { target, ...tooltipLinkProps } = props
  const backlink = SOURCE_TO_BACKLINK[target.Source]
  if (!backlink) return null
  // Use `>>?` so the entity sheet pushes onto the view-sheet
  // history stack instead of replacing this uptime sheet --
  // operators can step back via the breadcrumb to keep their
  // place in the incident triage flow.
  const href = `>>?v=${backlink.kind}:${encodeURIComponent(target.Identifier)}`
  return (
    <TooltipLink
      to={href}
      size="sm"
      iconSrc="layers"
      isStacked
      {...tooltipLinkProps}
    >
      {backlink.label}
    </TooltipLink>
  )
}

export default UptimeTargetLink
